import { useQuery } from "@tanstack/react-query";
import { http } from "../../../../../../services/HttpService";
import { HTTP_ENDPOINTS } from "../../../../../../consts/api";

export const useCancellationFees = (params, options = {}) => {
  return useQuery(
    ["cancellationFeesReport", params],
    async () => {
      const res = await http.get(HTTP_ENDPOINTS.getCancelationFees(), {
        params,
      });
      const composeResponse = {
        clinics: res.data.data.clinics,
        reportData: res.data.data.report_data,
        reportHeader: res.data.data.report_header,
      };
      return composeResponse;
    },
    options,
  );
};
